import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useStopwatch } from 'react-timer-hook'

import { IconModalClose } from 'assets/svg/sprite'
import './_mediaRecorder.scss'

interface Props {
    type: string
    status: boolean
    handleClose: () => void
    handleAudioStart: () => void
    handleAudioStop: () => void
}

const formatDuration = (duration: {
    seconds: number
    minutes: number
    hours: number
}) => {
    const { seconds, minutes, hours } = duration
    return {
        seconds: seconds < 10 ? '0' + seconds : seconds.toString(),
        minutes: minutes < 10 ? '0' + minutes : minutes.toString(),
        hours: hours < 10 ? '0' + hours : hours.toString()
    }
}

export const AudioRecorder = ({
    type,
    status,
    handleClose,
    handleAudioStart,
    handleAudioStop
}: Props) => {
    const [mediaRecordingSupported, setMediaRecordingSupported] = useState(true)

    const { t } = useTranslation()

    const {
        seconds: sec,
        minutes: min,
        hours: h,
        start,
        pause,
        reset,
        isRunning
    } = useStopwatch({ autoStart: false })

    const { seconds, minutes } = formatDuration({
        seconds: sec,
        minutes: min,
        hours: h
    })

    useEffect(() => {
        checkMediaPlayer()
    }, [])

    const checkMediaPlayer = async () => {
        try {
            await navigator.mediaDevices.getUserMedia({
                audio: true
            })
        } catch (err) {
            setMediaRecordingSupported(false)
        }
    }

    if (!mediaRecordingSupported) {
        return (
            <div className='mediaRecorder'>
                <div className='mediaRecorder__header'>
                    <div></div>
                    <h3 className='mediaRecorder__header__title'>
                        {t('record')} {type}
                    </h3>
                    <div
                        className='mediaRecorder__header__close'
                        onClick={() => {
                            handleClose()
                        }}
                    >
                        <IconModalClose color='#fff' />
                    </div>
                </div>
                <div className='mediaRecorder__card'>
                    <div className='mediaRecorder__error'>
                        {t('mediaRecordingNotSupportedOnIos')}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='mediaRecorder mediaRecorder__audio'>
            <div className='mediaRecorder__header'>
                <div></div>
                <h3 className='mediaRecorder__header__title'>
                    {t('record')} {type}
                </h3>
                <div
                    className='mediaRecorder__header__close'
                    onClick={() => {
                        handleClose()
                    }}
                >
                    <IconModalClose color='#fff' />
                </div>
            </div>

            <div className='mediaRecorder__controls'>
                <div className='mediaRecorder__controls__duration'>
                    {minutes}:{seconds}
                </div>
                <div className='mediaRecorder__controls__actions'>
                    <div
                        className={`mediaRecorder__controls__actions__wrapper ${
                            isRunning ? 'recording' : ''
                        }`}
                        onClick={() => {
                            if (!status) {
                                handleAudioStart()
                                start()
                            } else {
                                reset()
                                pause()
                                handleAudioStop()
                                handleClose()
                            }
                        }}
                    >
                        {status ? (
                            <div className='mediaRecorder__controls__actions--stop'></div>
                        ) : (
                            <div className='mediaRecorder__controls__actions--record'></div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
